const Chat = () => import('@/views/Chat.vue');

const routes = [
  {
    path: '/chat/:idTransacao',
    name: 'chat',
    component: Chat,
    props: route => ({
      transacaoId: +route.params.idTransacao,
    }),
    meta: {
      disabledChatbox: true,
      title: 'Minhas mensagens',
    },
  },
];

export default routes;
